
export default (values) => {
    let errors = {};

    if (!values.group) {
        errors.type = 'Complete el nombre del grupo';
    }
    return errors;
};
